<!--
  Componente de modal de carregamento, exibindo um spinner circular e um texto opcional.
  Recebe um v-model (modelValue) para controle de exibição e uma prop de texto.
-->

<template>
  <w-dialog v-model="modelValueProxy" persistent :width="300">
    <div class="row justify-content-md-center">
      <w-progress class="ma1 w-progress" circle size="7em"></w-progress>
    </div>
    <p class="text-center">{{ text }}</p>
  </w-dialog>
</template>

<script>
export default {
  name: 'ModalLoading',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    text: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  computed: {
    modelValueProxy: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit('update:modelValue', val);
      }
    }
  }
}
</script>